
import { Button } from 'primereact/button';


function MyButton(props) {
    return (
        <Button {...props} style={{
            fontWeight: 500,
            whiteSpace: "nowrap"
        }} />
    );
}

export default MyButton;